export default __webpack_public_path__ + "static/media/Q1_1.252fc5f9.png";